import { Component, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ui-animated-success-error',
  templateUrl: './animated-success-error.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: 'animated-success-error.component.scss',
})
export class AnimatedSuccessErrorComponent {
  public successVisible: WritableSignal<boolean> = signal(false);
  public errorVisible: WritableSignal<boolean> = signal(false);

  public showSuccess(): Promise<void> {
    return new Promise((resolve) => {
      this.successVisible.set(true);
      setTimeout(() => {
        this.successVisible.set(false);
        resolve();
      }, 1200);
    });
  }

  public showError(): Promise<void> {
    return new Promise((resolve) => {
      this.errorVisible.set(true);
      setTimeout(() => {
        this.errorVisible.set(false);
        resolve();
      }, 1200);
    });
  }
}
